// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"153":"8a778f41","260":"ce359c73","668":"9e0b767f","762":"a64a1f3d"}[chunkId] + ".js";
};